'use client';

import { FaIcon, faClock, faTruck } from '../../../../components/icon';

import utilsStyles from '../../../../styles/modules/utils.module.scss';
import type { LotteryBenefit, LotteryCustomOption, LotteryPrice } from '../../types';
import ShippingAlert from '../ShippingAlert/ShippingAlert';
import styles from './LotteryDetailHeader.module.scss';

function LotteryDetailHeader({
  name,
  name_en,
  endAt,
  status,
  benefit,
  isCampaign = false,
  showSpKv = false,
  estimatedShippingDate,
  additionalShippingFeePerTimes,
  price,
  shippingFee,
  additionalShippingFee,
  drawFee,
  startAt,
  endAtText,
  locale,
  eventStatusLabel,
  estimatedShippingDateText,
  hasShippingFee,
  isShowEstimatedShippingDate,
}: {
  name: string;
  name_en?: string;
  endAt: string;
  status: string;
  benefit: Array<LotteryBenefit>;
  isGlobal?: boolean;
  isCampaign?: boolean;
  showSpKv?: boolean;
  estimatedShippingDate?: string | null;
  additionalShippingFeePerTimes?: number;
  price?: LotteryPrice;
  shippingFee: string;
  additionalShippingFee: string;
  drawFee: string;
  startAt: string;
  endAtText: string;
  locale: string;
  eventStatusLabel: (status: string) => string;
  estimatedShippingDateText: (params: { eventEndAt: string; estimatedShippingDate?: string }) => string;
  hasShippingFee: (shippingFee: number, additionalShippingFee: number) => boolean;
  isShowEstimatedShippingDate: boolean;
}) {
  return (
    <header className={styles.componentStyle}>
      {/* /開催中、開催予定等の表示ラベル部分の制御 */}
      {showSpKv && (
        <div className={styles.itemStatus}>
          <img src={eventStatusLabel(status)} alt='' />
        </div>
      )}

      <p className={`${styles.itemTitle} ${utilsStyles.textBold}`}>{locale === 'en' ? name_en : name}</p>
      <div className={styles.labelArea}>
        {isCampaign ? (
          <div className={styles.campaignLabel}>
            <span className={utilsStyles.textBold}>キャンペーンくじ</span>
          </div>
        ) : (
          <div className={styles.benefitList}>
            {benefit.length > 0 && <p className={`${styles.benefitListItem} ${utilsStyles.textBold}`}>特典あり</p>}
          </div>
        )}
      </div>
      <div className={`${styles.lotteryDate} ${utilsStyles.textBold}`}>
        <FaIcon icon={faClock} />
        &nbsp;
        {startAt}~{endAtText}
      </div>
      {isShowEstimatedShippingDate && (
        <div className={`${styles.estimateShippingDate} ${utilsStyles.textBold}`}>
          <FaIcon icon={faTruck} />
          &nbsp;
          {estimatedShippingDateText({ eventEndAt: endAt, estimatedShippingDate: estimatedShippingDate || undefined })}
        </div>
      )}
      {drawFeeAnnotation(hasShippingFee, price, drawFee)}
      {shippingAlert(shippingFee, additionalShippingFee, hasShippingFee, additionalShippingFeePerTimes, price)}
    </header>
  );
}

function drawFeeAnnotation(
  hasShippingFee: (shippingFee: number, additionalShippingFee: number) => boolean,
  price?: LotteryPrice,
  drawFee?: string,
) {
  if (!price) return <></>;
  if (price.drawFee === 0) return <></>;
  return (
    <div className={`${utilsStyles.flexRowNowrap} ${utilsStyles.alignCenter} ${styles.feeTextContainer}`}>
      <p className={styles.drawFeeText}>1回 {drawFee}円（税込）&nbsp;</p>
      <p className={utilsStyles.textXSmall}>
        /&nbsp;
        {hasShippingFee(price.shippingFee, price.additionalShippingFee)
          ? '（配送手数料を含まない）'
          : '（配送手数料を含む）'}
      </p>
    </div>
  );
}

function shippingAlert(
  shippingFee: string,
  additionalShippingFee: string,
  hasShippingFee: (shippingFee: number, additionalShippingFee: number) => boolean,
  additionalShippingFeePerTimes?: number,
  price?: LotteryPrice,
) {
  if (!price) return <></>;
  if (price.shippingFee === 0) return <></>;
  if (!hasShippingFee(price.shippingFee, price.additionalShippingFee)) return <></>;
  return (
    <div className={styles.feeTextContainer}>
      <ShippingAlert
        price={price}
        shippingFee={shippingFee}
        additionalShippingFee={additionalShippingFee}
        additionalShippingFeePerTimes={additionalShippingFeePerTimes}
      />
    </div>
  );
}

export default LotteryDetailHeader;
